import React, { Fragment, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Paper,
  Grid,
  Table,
  TableRow,
  TableBody,
  TableHead,
  Avatar,
  IconButton,
  Button,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import TableFixedHeaderWraper from "../HOC/CustomComponents/TableWithFixedHeader";
import { FixedTableCell } from "../HOC/CustomComponents/FixedTableCell";
import config from "../../config.json";
import { DeleteOutline } from "@mui/icons-material";
import MutationWithDialog from "../HOC/CustomComponents/MutationWithDialog";
import { DELETE_ATTCHMENT } from "./Graphql";
import CustomDialog from "../HOC/CustomComponents/CustomDialog";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"; // generic file
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { StyledTableRow } from "../HOC/CustomComponents/PackagesTableView/Tabs";


const PREFIX = "TableOFAttatchment";

const classes = {
  table: `${PREFIX}-table`,
  tableContainer: `${PREFIX}-tableContainer`,
  tableContainerTabes: `${PREFIX}-tableContainerTabes`,
  title: `${PREFIX}-title`,
  toolbar: `${PREFIX}-toolbar`,
  header: `${PREFIX}-header`,
  focus: `${PREFIX}-focus`,
  tableRow: `${PREFIX}-tableRow`,
  packageType: `${PREFIX}-packageType`,
  addIcon: `${PREFIX}-addIcon`,
  borderTable: `${PREFIX}-borderTable`,
  tabpanel: `${PREFIX}-tabpanel`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.borderTable}`]: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  [`& .${classes.table}`]: {
    display: "grid",
    width: "100%",
    alignItems: "center",
  },

  [`& .${classes.tableContainer}`]: {
    minHeight: "250px",
  },
  [`& .${classes.tableContainerTabes}`]: {
    minHeight: "205px",
  },

  [`& .${classes.title}`]: {
    flex: 1,
  },

  [`& .${classes.header}`]: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    borderBottom: "1px solid " + theme.palette.divider,
    borderRight: "1px solid " + theme.palette.divider,
  },
  [`& .${classes.toolbar}`]: {
    borderBottom: "1px solid" + theme.palette.background.paper,
  },

  [`& .${classes.focus}`]: {
    backgroundColor: theme.palette.action.hover,
  },

  [`& .${classes.tableRow}`]: {
    "&:hover": {
      cursor: "pointer",
    },
  },

  [`& .${classes.packageType}`]: {
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
    },
  },
  [`& .${classes.addIcon}`]: {
    color: theme.palette.success.main,
  },
  [`& .${classes.tabpanel}`]: {
    margin: theme.spacing(2, 0),
    padding: 0,
  },

}));



export default function TableOFAttatchment({ attachments, setAutocompleteValues, setValue, watch, edit, attachmentError,
  setAttachmentError }) {
  const [dialog, setDialog] = useState({
    open: false,
    fileName: null
  });
  const closeDialog = () => setDialog({
    open: false,
    fileName: null
  });

  function updateErrorIndex(index) {
    setAttachmentError((prevErrors) => {
      const newErrors = {};
      Object.keys(prevErrors).forEach((key) => {
        const match = key.match(/input\.attachments\.(\d+)\.file/);
        if (match) {
          const errorIndex = parseInt(match[1], 10);
          if (errorIndex > index) {
            newErrors[`input.attachments.${errorIndex - 1}.file`] =
              prevErrors[key];
          } else if (errorIndex < index) {
            newErrors[key] = prevErrors[key];
          }
        }
      });
      return newErrors;
    });
  }

  const { t } = useTranslation();
  let getBackendUri = (imgPath) => {
    const domain = config.backend.domain
      ? config.backend.domain
      : window.location.hostname;
    return `${config.backend.protocol}://${domain}:${config.backend.port}/${imgPath}`;
  };
  const handleRemoveFile = (fileName) => {
    // Filter out from state (attachments may have File or backend objects)
    const remainingFiles = attachments.filter((_, i) => i !== fileName);


    setAutocompleteValues((prev) => ({
      ...prev,
      attachments: remainingFiles,
    }));
    // Filter out from form watch (if it has Files)
    let attachmentWatch = watch("attachments") || [];
    const remainingFilesFromWatch = attachmentWatch.filter((_, i) => i !== fileName)
    // Collect only backend fileNames (skip raw File objects)
    const fileNames = remainingFiles
      .filter((f) => f.fileName) // only keep backend items with fileName
      .map((f) => f.fileName);
    // Update form values
    setValue("attachments", remainingFilesFromWatch);
    setValue("fileName", fileNames.length > 0 ? fileNames.join(", ") : "", {
      shouldValidate: true,
    });

    // close dialog
    setDialog({ open: false, file: null });
  };
  const priceModesTab = (
    <Grid
      container item className={classes.tabpanel}
    >
      {!attachments && edit ? (
        <Grid className={classes.tabpanel}>
          <FullScreenLoading minHeight={"100px"} />
        </Grid>
      ) : (<TableFixedHeaderWraper> <Table aria-label="collapsible table">
        <TableHead>
          <StyledTableRow>
            <FixedTableCell>{t("#")}</FixedTableCell>
            <FixedTableCell>{t("file")}</FixedTableCell>
            {edit && <FixedTableCell>{t("delete")}</FixedTableCell>}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {attachments &&
            attachments?.map((row, index) => {
              return (
                <TableRow

                  hover
                  key={index}

                >
                  <FixedTableCell>
                    {index + 1}
                  </FixedTableCell>
                  <FixedTableCell>
                    {row?.path ? (
                      // backend file
                      row.path.match(/\.(jpeg|jpg|png|webp|gif)$/i) ? (
                        <a
                          href={getBackendUri(row?.path)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Avatar>
                            <img
                              width="75px"
                              src={getBackendUri(row?.path)}
                              alt="RowImage"
                              style={{ cursor: "pointer" }}
                            />
                          </Avatar>
                        </a>
                      ) : (
                        <Tooltip title="Download">
                          <IconButton
                            component="a"
                            href={getBackendUri(row?.path)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {getFileTypeIcon(row?.path)}
                            {/* <DownloadIcon fontSize="small" /> */}
                          </IconButton>
                        </Tooltip>
                      )
                    ) : (
                      // new uploaded file (before saving to backend)
                      row?.file?.startsWith("data:image") ? (
                        <a href={row?.file} download={row?.fileName}>
                          <Avatar>
                            <img
                              width="75px"
                              src={row?.file}
                              alt="RowImage"
                              style={{ cursor: "pointer" }}
                            />
                          </Avatar>
                        </a>
                      ) : (
                        <Tooltip title={row?.fileName || "Download"}>
                          <IconButton href={row?.file} download={row?.fileName}>
                            {getFileTypeIcon(row?.fileName)}

                          </IconButton>
                        </Tooltip>
                      )
                    )}
                    {attachmentError && (
                      <Typography color="error" variant="caption">
                        {
                          attachmentError[
                          `input.attachments.${index
                          }.file`
                          ]
                        }
                      </Typography>
                    )}
                  </FixedTableCell>
                  {edit && <FixedTableCell className={classes.editIcon}>
                    {row?.path ? (
                      <MutationWithDialog
                        mutaion={DELETE_ATTCHMENT.query}
                        icon={DeleteOutline}
                        permission={true}
                        iconTooltip={t("delete")}
                        dialogTitle={t("delete")}
                        dialogContent={t("confirmation")}
                        mutaionProps={{ variables: { id: parseInt(row.id) } }}
                        onCompleted={() =>
                          setAutocompleteValues((prev) => ({
                            ...prev,
                            attachments: prev.attachments.filter((item) => item.id !== row.id),
                          }))
                        }
                        onCompleteMessage={t("categoryDeleted")}
                      />
                    ) : (
                      <Tooltip title={t("delete")}>
                        <IconButton

                          onClick={() => {
                            setDialog(() => ({
                              open: true,
                              fileName: index
                            }));

                          }}
                          color={"primary"}
                        >
                          <DeleteOutline fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </FixedTableCell>}
                </TableRow>
              );
            })}

        </TableBody>
      </Table>  </TableFixedHeaderWraper>)}

    </Grid>
  );

  return (
    <StyledGrid
      container
      item
      sm={12}
      md={12}
      component={Paper} >
      <CustomDialog
        title={t("confirmationMessage")}
        fullWidth
        maxWidth="xs"
        onClose={closeDialog}
        content={t("deleteDesc")}
        open={dialog?.open}
        actions={
          <Fragment>
            <Button color="primary" onClick={closeDialog}>
              {t("cancel")}
            </Button>
            <Button
              color="primary"

              onClick={() => { handleRemoveFile(dialog?.fileName); updateErrorIndex(dialog?.fileName) }}
            >
              {t("confirm")}
            </Button>
          </Fragment>
        }

      />


      {priceModesTab}

    </StyledGrid>
  );
}

const getFileTypeIcon = (path) => {
  if (!path) return <InsertDriveFileIcon />;

  const ext = path.split(".").pop().toLowerCase();
  switch (ext) {
    case "pdf":
      return <PictureAsPdfIcon color="error" />;
    case "xls":
    case "xlsx":
      return <DescriptionIcon color="success" />;
    case "doc":
    case "docx":
      return <DescriptionIcon color="primary" />;
    default:
      return <InsertDriveFileIcon />;
  }
};

